// test753
(753 && 0);
